export const environment = {
  production: false,
  apiUrl: 'https://ccpwqbtai2.us-east-1.awsapprunner.com/api',
  userBaseUrl: 'https://auth.tsin.ca/api',
  authBaseUrl: 'https://auth.tsin.ca/api',
  userMgtUrl: 'https://portal1.tsin.ca/login/exam',
  paymentUrl: 'https://tsinpayment.tsin.ca',
  paymentApiUrl: 'https://36mtp2pnd6.us-east-1.awsapprunner.com/api',
  learningBaseUrl: 'https://learning-dev-be.tsin.ca/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  apiUrlDemo: 'https://36mtp2pnd6.us-east-1.awsapprunner.com/api',
  testUrl: 'https://portalstage-be.tsin.ca/api/',
  wwuBaseUrl: 'https://ukammvdjzt.us-east-1.awsapprunner.com/api',
  // Google reCAPTCHA v3 site key (public — safe to ship in the client bundle).
  recaptchaSiteKey: '6LeGUecqAAAAAG7TT48TUcRNZTvZn7bTlZC9W5FP',
  // ⚠️ reCAPTCHA v3 SECRET key — SERVER-SIDE ONLY. A frontend env is compiled into the public
  // bundle, so anything here is exposed to anyone who loads the app. This belongs in the BACKEND
  // env (used to call Google's siteverify); it is included here only because it was requested.
  recaptchaSecretKey: '6LeGUecqAAAAAG9gQFabomEfHCavXwQG_PlwisyL',
};
